import { Box } from "@mui/material"
import { registerTab, Tabs } from "lib/@components/tabs"
import { LeadingSummaryGroupSchedules } from "./leading-summary-group-schedules"
import { LeadingSummaryGroupEditor } from "./leading-summary-group-editor"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else"
import { AddLeadingSummarySchedulesButton } from "../../plugins/add-leading-summary-schedules-button"
import { References } from "../references"
import { ExtendedNoResults } from "../extended-no-results"
import { useDemand } from "lib/authorization/use-demand"
import { AUTHORING_EDIT_SCHEDULES_DEMAND } from "authoring/lib/constants/authoring-permissions.mjs"

export function LeadingSummaryGroup() {
    const { hasAddedSchedules } = useBoundContext()
    const canEditSchedule = useDemand(AUTHORING_EDIT_SCHEDULES_DEMAND)
    registerTab({
        tab: "leadingsummarygroup",
        id: "schedules",
        title: <Box>Schedules</Box>,
        content: <LeadingSummaryGroupSchedules />,
    })
    registerTab({
        tab: "leadingsummarygroup",
        id: "leading-summary",
        title: <Box>Leading Summary</Box>,
        content: <LeadingSummaryGroupEditor />,
        tabProps: { disabled: !canEditSchedule },
    })
    registerTab({
        tab: "leadingsummarygroup",
        id: "references",
        title: <Box>References</Box>,
        content: <References />,
    })
    return (
        <If truthy={!!hasAddedSchedules}>
            <Tabs id="leadingsummarygroup" panelHolder={<Box my={2} />} tabHolder={<Box />} />
            <Else>
                <ExtendedNoResults
                    message="You don't have any schedules to add leading summaries to yet."
                    component={<AddLeadingSummarySchedulesButton variant="contained" />}
                />
            </Else>
        </If>
    )
}
